import { createPortal } from "react-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import ResearcherLikeCommentActions from "./IndependentResearcher/ResearcherLikeCommentActions";
import SendInterestModal from "./IndependentResearcher/SendInterestModal";
import { useSearchParams } from "react-router-dom";
import FileViewer from './FileViewer'
const BASE_URL = process.env.REACT_APP_BASE_URL;
const MarketplaceFeedDetailsModal = ({ isOpen, onClose, id, research_type, type,is_Liked, likeCount,onLikeUpdate,onReadsUpdate}) => {
  const [pubExpanded, setPubExpanded] = useState(false);
  const [open, setOpen] = useState(false)
  const [post, setPost] = useState(null);
  const [urlParams, setUrlParams] = useSearchParams();
  // console.log("Post details:",post?.profile_data?.user)
  const activeTab = urlParams.get("tab") || "feed";
    useEffect(() => {
    if (!isOpen || !id) return;

    const fetchPostDetails = async () => {
      try {
        setPost(null); // ✅ prevent old data flash

        const response = await axios.get(
          `${BASE_URL}/marketplace/researcher/feed/${id}?research_type=${research_type}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
              "x-api-key": process.env.REACT_APP_X_API_KEY,
            },
          }
        );

        setPost(response.data);
      } catch (error) {
        console.error("Error fetching post details:", error);
      }
    };

    fetchPostDetails();
  }, [id, research_type, isOpen]);
  
  const handleClose = async () => {
    let latestPost = post;

    // If we haven't fetched the latest views yet (or the fetch is still in-flight), attempt to fetch on close.
    if ((!latestPost || latestPost.views === undefined || latestPost.views === null) && id && research_type) {
      try {
        const res = await fetch(
          `${BASE_URL}/marketplace/researcher/feed/${id}?research_type=${research_type}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
              "x-api-key": process.env.REACT_APP_X_API_KEY,
            },
          }
        );
        if (res.ok) {
          const data = await res.json();
          setPost(data);
          latestPost = data;
        }
      } catch (err) {
        console.error("Error fetching post data on close:", err);
      }
    }

    if (onReadsUpdate && latestPost) {
      onReadsUpdate(latestPost.id, latestPost.views || 0);
    }

    onClose();
    // Reset URL
    window.history.pushState({}, "", `/marketplace/feed?tab=${activeTab}`);
  };

  if (!isOpen) return null;
  return createPortal(<div className="fixed inset-0 z-[100000] bg-black/50 flex items-center justify-center overflow-hidden">
    <div className="w-full h-full sm:w-screen sm:h-screen bg-white relative flex flex-col sm:flex">
      <button
        onClick={handleClose}
        className="cursor-pointer absolute top-0 left-0 sm:top-4 sm:left-4 w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-gray-200 rounded-full hover:bg-gray-300 z-10"
      >
        ✕
      </button>
      <div className="flex flex-col sm:flex-row w-full h-full">
        {/* first part */}
        <div className="w-full h-[60vh] sm:h-full sm:w-9/12 p-2 overflow-hidden flex items-center justify-center bg-[#F9F7F4]">
          <div className="w-full mt-12 md:mt-0 md:w-[90%] h-full   rounded-lg overflow-hidden">
            <div className="flex justify-between">
              <div className="text-lg text-gray-900 mb-2 mt-2 font-bold" >
                {post?.name}
              </div>
              {
                (research_type === 'opportunity' || research_type === 'lab_opportunity') && (
                  <button
                    onClick={() => setOpen(true)}
                    className="mt-4 px-5 py-2.5 bg-[#0f6abf] text-white text-sm font-medium rounded-full hover:bg-[#0a5ca8] transition-colors disabled:opacity-50"
                  >
                    Send Interest
                  </button>
                )
              }
            </div>
            {
              research_type === 'opportunity' || research_type === 'lab_opportunity' ? <div className="flex flex-wrap gap-2">
                <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
                  {post?.domain}
                </span>
                <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-blue-50 text-blue-600 border border-blue-100">
                  {post?.collaboration}
                </span>
                <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
                  {post?.maturity}
                </span>
                <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-green-50 text-green-600 border border-green-100">
                  {post?.visibility}
                </span>
              </div> : <div className="flex flex-wrap gap-2">
                <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
                  {post?.field_of_interest}
                </span>
                <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-blue-50 text-blue-600 border border-blue-100">
                  {post?.area_of_interest}
                </span>
                <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
                  {post?.topic_of_interest}
                </span>
                 <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {post?.research_type === 'theoreticalidea' || 'labtheoreticalidea' && "Idea"}
      {post?.research_type === 'prototype' || 'labprototype' && "PoC"}
      {post?.research_type === 'labexperiment' || 'lab_labexperiment' && "Lab-ready"}
      {post?.research_type === 'industrialapplication' || 'labindustrialapplication'  && "Industry Challenge"}
    </span>
                <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-green-50 text-green-600 border border-green-100">
                  {post?.visibility}
                </span>
              </div>
            }
            <div className="w-full h-full rounded-[10px] mt-4 cursor-pointer" >
              <FileViewer publication_type={post?.publication_type} file={post?.file} name={post?.name} />
            </div>
          </div>
        </div>
        <div className="relative w-full sm:w-3/12 h-[40vh] sm:h-full flex flex-col bg-white overflow-hidden">
          <div className="flex-1 overflow-y-auto p-3 sm:pt-6 sm:px-4">
            {/* User Info - Mobile optimized */}
            <div className="flex items-center gap-3">
              <div className="relative">
                <img
                  src={post?.profile_data?.profile_picture}
                  alt="User"
                  className="w-10 h-10 sm:w-12 sm:h-12 cursor-pointer rounded-xl object-cover border-2 border-white shadow-sm"
                //  onClick={()=>navigate(`${currentUserId === post?.userId ? "/profile-view" : `/user-profile/${post?.user_profile?.id}`}`)}
                />
                <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-white"></div>
              </div>
              <div className="flex flex-col">
                <span className="font-semibold text-gray-900 text-sm sm:text-base">
                  {post?.profile_data?.name}
                </span>
              </div>
            </div>
            {
              post?.description &&
              <div className="mt-3 sm:mt-4 text-base sm:text-lg  text-gray-900 mb-2 break-words">
                {pubExpanded || (post?.description?.length || 0) <= 120
                  ? post?.description
                  : post?.description.slice(0, 120) + "..."}

                {(post?.description?.length || 0) > 120 && (
                  <span
                    onClick={() => setPubExpanded(!pubExpanded)}
                    className="text-blue-600 cursor-pointer ml-1 font-medium"
                  >
                    {pubExpanded ? " Read less" : " Read more"}
                  </span>
                )}
              </div>
            }
           <div className="border-t pt-4">
  {post && (
    <ResearcherLikeCommentActions
      key={post.id} // ✅ forces fresh instance per post
      postId={post.id}
      type={post.research_type}
      is_Liked={post.is_liked}
      likeCount={post.like_count}
      isOpen={true}
     onLikeUpdate={(updated) => {
  onLikeUpdate(updated);

  setPost(prev => ({
    ...prev,
    like_count: updated.like_count,
    is_liked: updated.is_liked,
  }));
}}
    />
  )}
</div>
          </div>
        </div>
      </div>
    </div>
    <SendInterestModal isOpen={open} onClose={() => setOpen(false)} postId = {id} research_type = {research_type} postOwnerId={post?.profile_data?.user} />
  </div>,
    document.body
  )
};

export default MarketplaceFeedDetailsModal;